<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';

import CampaignForm from 'dashboard/components-next/Marketing/CampaignForm.vue';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

// After creating, the operator wants to see it queued, so we land on the history.
const handleCreated = () => {
  router.push({ name: 'marketing_history', params: route.params });
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="sticky top-0 z-10 px-4 md:px-6">
      <div class="w-full max-w-6xl mx-auto">
        <div
          class="flex flex-col justify-center w-full min-h-[5rem] py-3 gap-0.5"
        >
          <span class="text-heading-1 text-n-slate-12">
            {{ t('MARKETING.CAMPAIGN.HEADER_TITLE') }}
          </span>
          <span class="text-sm text-n-slate-11">
            {{ t('MARKETING.CAMPAIGN.HEADER_SUBTITLE') }}
          </span>
        </div>
      </div>
    </header>
    <main class="flex-1 px-4 md:px-6 overflow-y-auto">
      <div class="w-full max-w-6xl mx-auto py-4">
        <CampaignForm @created="handleCreated" />
      </div>
    </main>
  </section>
</template>
